import { useEffect, useState } from "react";
import { Button, Checkbox, Col, Form, Input, Row, Select, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { showError, showMessage, useLayoutBreaks } from "helpers/utility";
import useAjax from "helpers/ajax";
import CSelect from "components/CSelect";
import CInput from "components/CInput";

const CreateUser = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const breaks = useLayoutBreaks();
  const { fetch, get } = useAjax();
  const edit = state ? true : false;
  const [roles, setRoles] = useState([]);

  const onFinish = (values) => {
    const method = edit ? "put" : "post";
    const data = { ...values, userID: state?.userID };
    fetch(method, "api/v1/users", { ...data })
      .then((resp) => {
        showMessage(resp.success, resp.message).then(() => {
          if (resp.success) {
            navigate("/security/users");
          }
        });
      })
      .catch((err) => {
        showError(err);
      });
  };

  useEffect(() => {
    get("api/v1/lookups/getroles")
      .then((resp) => {
        setRoles(resp);
      })
      .catch((err) => {
        showError(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      layout="vertical"
      initialValues={{ ...state, active: !edit ? true : state.active }}
      onFinish={onFinish}
    >
      <Row gutter={24}>
        <Col {...breaks}>
          <Form.Item
            label="User name"
            name="userName"
            rules={[{ required: true }, { min: 5 }]}
          >
            <CInput allowWhiteSpace={false} />
          </Form.Item>
          <Form.Item label="Role" name="roleID" rules={[{ required: true }]}>
            <CSelect>
              {roles.map((r) => (
                <Select.Option key={r.value} value={r.value}>
                  {r.text}
                </Select.Option>
              ))}
            </CSelect>
          </Form.Item>

          {!edit && (
            <>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true }, { min: 5 }]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="Confirm password"
                name="confirmPassword"
                dependencies={["password"]}
                rules={[
                  { required: true },
                  { min: 5 },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Password doesn't match.")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
            </>
          )}
          <Form.Item
            label="Display name"
            name="displayName"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Email address"
            name="emailAddress"
            rules={[{ required: true }]}
          >
            <Input type="email" />
          </Form.Item>

          <Form.Item valuePropName="checked" label="Active" name="active">
            <Checkbox />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
              <Button
                htmlType="button"
                onClick={() => {
                  navigate("/security/users");
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
export default CreateUser;
